import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

import { Appointment } from '../models/appointment.model';

import { objectToHttpParams, snakeizeParams } from '../../util';
import { Answer } from '../models/form.model';

export interface IAppointmentCreation {
  readonly availabilityId: number;
  readonly patientId: number;
  readonly visitReason: any;
  readonly requestSessionUuid: number;
  readonly formAnswer?: any;
}
export interface IMultiAppointmentCreation {
  readonly availabilityIds: number;
  readonly patientId: number;
  readonly visitReason: any;
  readonly requestSessionUuid: number;
  readonly formAnswer?: any;
}

@Injectable()
export class AppointmentsService {
  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  create(params: IAppointmentCreation): Observable<Appointment> {
    return this.http.post<Appointment>(`/api/v2/appointments`, snakeizeParams(params)); 
  }

  createMultiple(params: IMultiAppointmentCreation): Observable<Appointment> {
    return this.http.post<Appointment>(`/api/v2/multi_appointments`, snakeizeParams(params)); 
  }

  getOfferingPatients(offeringId): Observable<any> {
    return this.http.get<any>(`/api/v2/appointments/offerings/${offeringId}/patients`);
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/services/appointments.service.ts